import { Theme } from '@mui/material/styles';

export const getStyles = (theme: Theme) => ({
  grow: {
    flexGrow: 1,
  },
  checkboxTreeContainer: {
    width: '100%',
    minHeight: 320,
    border: `solid #eee 1px`,
    borderRadius: '3px',
    padding: '10px',
  },
  provisionTreeContainer: {
    margin: `${theme.spacing(1)} ${theme.spacing(2)}`,
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'column',
    alignItems: 'center',
  },
  loaderContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  // provisionTreeContainer: {
  //   margin: `${theme.spacing(1)} ${theme.spacing(2)}`,
  //   display: 'flex',
  //   flexWrap: 'wrap',
  //   width: 800,
  //   [theme.breakpoints.down('lg')]: {
  //     width: 725,
  //   },
  //   [theme.breakpoints.down('md')]: {
  //     width: 650,
  //   },
  //   [theme.breakpoints.down('sm')]: {
  //     width: 550,
  //   },
  //   [theme.breakpoints.down('xs')]: {
  //     width: 425,
  //   },
  //   flexDirection: 'column',
  //   alignItems: 'center',
  // },
  searchContainer: {
    width: '70%',
    justifySelf: 'center',
    padding: theme.spacing(1, 1, 1, 1),
  },
  searchTitle: {
    textAlign: 'left',
    fontWeight: 'bold',
  },
  search: {
    position: 'relative',
    borderRadius: `${theme.shape.borderRadius}px`,
    borderColor: 'black',
    backgroundColor: 'white',
    width: '100%',
  },
  searchIcon: {
    pointerEvents: 'none',
  },
  checkboxSubmit: {
    margin: theme.spacing(3, 0, 2),
    maxWidth: 250,
    minWidth: 190,
    [theme.breakpoints.up('sm')]: {
      display: 'flex',
    },
  },
  node: {
    display: 'flex',
    justifyContent: 'space-between',
    '&:hover': {
      color: theme.palette.primary.light,
      '& $bracket': {
        border: `solid 2px ${theme.palette.primary.light}`,
        borderRight: 'none',
      },
    },
  },
  bracket: {
    width: '10px',
    marginLeft: '24px',
    border: 'solid 1px #eee',
    borderRight: 'none',
  },
  searchResult: {
    width: '100%',
    maxHeight: '64vh',
    overflow: 'auto',
    padding: '1em 2em',
    '& table': {
      lineHeight: 'normal',
      width: '100%',
      height: '100%',
      fontSize: '16px',
      '& tr': {
        borderSpacing: '0px',
        padding: '0px',
        '& td': {
          // padding: '0px 16px',
        },
        '& td[show-border=true]': {
          // borderLeft: 'solid 1px #c8c8c8',
          // borderRadius: '5px',
        },
        '& td:hover': {
          cursor: 'pointer',
          // backgroundColor: '#f5f5f5',
        },
      },
    },
  },
});
